// Generated on 2026-10-02T21:21:47.363Z
// This file contains preloaded products top brands data from the API
// Do not edit manually - use 'npm run generate:products-top-brands-data' to regenerate

export const preloadedProductsTopBrands: any = [
  {
    "marca": "DORMAN",
    "cantidadProductosVendidos": "59429"
  },
  {
    "marca": "NAKAMOTO",
    "cantidadProductosVendidos": "44881"
  },
  {
    "marca": "GSP NORTH AMERICA",
    "cantidadProductosVendidos": "43671"
  },
  {
    "marca": "WAGNER QUICKSTOP",
    "cantidadProductosVendidos": "31852"
  },
  {
    "marca": "FEBEST",
    "cantidadProductosVendidos": "29448"
  },
  {
    "marca": "ONNURI",
    "cantidadProductosVendidos": "27579"
  },
  {
    "marca": "VALVOLINE",
    "cantidadProductosVendidos": "27549"
  },
  {
    "marca": "BANDO",
    "cantidadProductosVendidos": "25761"
  },
  {
    "marca": "DENSO",
    "cantidadProductosVendidos": "23228"
  },
  {
    "marca": "DNJ",
    "cantidadProductosVendidos": "21966"
  },
  {
    "marca": "MAHLE ORIGINAL",
    "cantidadProductosVendidos": "21891"
  },
  {
    "marca": "BECK/ARNLEY",
    "cantidadProductosVendidos": "18237"
  },
  {
    "marca": "ECOGARD",
    "cantidadProductosVendidos": "17021"
  },
  {
    "marca": "FAG",
    "cantidadProductosVendidos": "14611"
  },
  {
    "marca": "555",
    "cantidadProductosVendidos": "14424"
  },
  {
    "marca": "BLUE PRINT",
    "cantidadProductosVendidos": "14376"
  },
  {
    "marca": "PRESTONE",
    "cantidadProductosVendidos": "14267"
  },
  {
    "marca": "DAYCO",
    "cantidadProductosVendidos": "13384"
  },
  {
    "marca": "PT",
    "cantidadProductosVendidos": "12701"
  },
  {
    "marca": "TENACITY",
    "cantidadProductosVendidos": "11726"
  },
  {
    "marca": "MOTORAD",
    "cantidadProductosVendidos": "11511"
  },
  {
    "marca": "MOOG",
    "cantidadProductosVendidos": "11110"
  },
  {
    "marca": "HS",
    "cantidadProductosVendidos": "10031"
  },
  {
    "marca": "WAGNER",
    "cantidadProductosVendidos": "10010"
  },
  {
    "marca": "STANDARD/INTERMOTOR",
    "cantidadProductosVendidos": "9829"
  },
  {
    "marca": "MOOG EU",
    "cantidadProductosVendidos": "9674"
  },
  {
    "marca": "NATIONAL",
    "cantidadProductosVendidos": "9428"
  },
  {
    "marca": "WALKER",
    "cantidadProductosVendidos": "9189"
  },
  {
    "marca": "EAGLE BHP",
    "cantidadProductosVendidos": "8759"
  },
  {
    "marca": "DORMAN PREMIUM",
    "cantidadProductosVendidos": "8407"
  }
];

export default preloadedProductsTopBrands;
